import React from "react";

import StaticPageStyles from "./static_pages.module.css"
import InstagramWarning from "../components/InstagramWarning";

function ReferralProgramConditions() {
    return (
        <div className={StaticPageStyles.staticPageContainer}>
            <InstagramWarning/>
            <h1>Умови реферальної програми LeelaOnline.net</h1>
            <h3>1. Вступ</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Ця реферальна програма дозволяє
                        зареєстрованим користувачам отримувати винагороду за залучення нових користувачів
                        до LeelaOnline.
                        Використовуючи унікальне реферальне посилання, ви можете запрошувати друзів,
                        знайомих та інших користувачів, та отримувати винагороду від їхніх платежів.</li>
                </ul>
            </p>

            <h3>2. Учасники програми</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Реферальна програма доступна лише зареєстрованим
                        користувачам нашого сайту. Участь у програмі є добровільною і безкоштовною.</li>
                </ul>
            </p>

            <h3>3. Унікальне реферальне посилання</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Кожен учасник програми отримує унікальне реферальне
                        посилання, яке можна знайти в особистому кабінеті.
                        Це посилання можна ділитися з іншими людьми для запрошення їх на сайт.</li>
                </ul>
            </p>

            <h3>4. Винагорода</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Винагорода є відсотком від платежів,
                        що здійснюють нові користувачі, зареєстровані за вашим реферальним посиланням.
                        Відсоток винагороди визначається індивідуально та може бути змінений на розсуд адміністрації сайту.</li>
                </ul>
            </p>

            <h3>5. Умови отримання винагороди</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Новий користувач повинен зареєструватися на нашому сайті, використовуючи ваше унікальне реферальне посилання.</li>
                    <li className={StaticPageStyles.staticPageText}>Новий користувач повинен здійснити платіж на сайті.</li>
                    <li className={StaticPageStyles.staticPageText}>Винагорода буде нараховуватися тільки за ті платежі, що були здійснені після реєстрації через реферальне посилання.</li>
                </ul>
            </p>

            <h3>6. Виплата винагороди</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Винагорода нараховується на ваш внутрішній рахунок на сайті.</li>
                    <li className={StaticPageStyles.staticPageText}>Ви можете запросити виплату винагороди, коли сума на вашому рахунку досягне мінімального порогу, встановленого адміністрацією сайту.</li>
                    <li className={StaticPageStyles.staticPageText}>Ви можете використати нараховану винагороду для оплати послуг сайту LeelaOnline</li>
                    <li className={StaticPageStyles.staticPageText}>Винагорода буде нараховуватися тільки за ті платежі, що були здійснені після реєстрації через реферальне посилання.</li>
                    <li className={StaticPageStyles.staticPageText}>Виплата може бути здійснена на ваш банківський рахунок, електронний гаманець або іншим способом, погодженим з адміністрацією сайту.</li>
                </ul>
            </p>

            <h3>7. Зміни умов реферальної програми</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Ми залишаємо за собою право змінювати умови реферальної програми в будь-який час без попереднього повідомлення. Ваше подальше використання реферальної програми після внесення змін означає вашу згоду з новими умовами.</li>
                </ul>
            </p>

            <h3>8. Зловживання та шахрайство</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Будь-які спроби зловживання або шахрайства з використанням реферальної програми призведуть до дискваліфікації учасника, анулювання всіх нарахованих винагород та можливого блокування облікового запису.</li>
                </ul>
            </p>

            <h3>9. Контактна інформація</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Якщо у вас є питання або зауваження щодо цієї реферальної програми, будь ласка, зв'яжіться з нами за електронною адресою support@leelaonline.net.</li>
                </ul>
            </p>
        </div>
    )
}

export default ReferralProgramConditions